import { createApi } from "@reduxjs/toolkit/query/react";
import { ADMIN, TagId, TagType } from "../../configs";
import {
  Admin,
  HttpMethod,
  IWriteAdmin,
  PaginatedResponse,
  SearchByName,
} from "../../types";
import { createBaseQuery } from "../helpers/baseQueryHelper";

const adminApi = createApi({
  reducerPath: ADMIN.reducerPath,
  baseQuery: createBaseQuery(ADMIN.baseUrl),
  tagTypes: ADMIN.tagTypes,
  endpoints(builder) {
    return {
      toggleAdminIsActiveStatus: builder.mutation<
        void,
        { adminId: string; isActive: boolean }
      >({
        query: ({ adminId, isActive }) => ({
          url: `/${adminId}/active`,
          method: HttpMethod.PATCH,
          params: { isActive },
        }),
        invalidatesTags: () => [{ type: TagType.Admin, id: TagId.LIST }],
      }),
      fetchAdmins: builder.query<PaginatedResponse<Admin>, SearchByName>({
        query: (searchQuery) => {
          return {
            url: "",
            method: HttpMethod.GET,
            params: searchQuery,
          };
        },
        providesTags: () => [{ type: TagType.Admin, id: TagId.LIST }],
      }),
      createAdmin: builder.mutation<Admin, IWriteAdmin>({
        query: (adminData) => ({
          url: "",
          method: HttpMethod.POST,
          body: adminData,
        }),
        invalidatesTags: () => [{ type: TagType.Admin, id: TagId.LIST }],
      }),
      updateAdmin: builder.mutation<
        void,
        { adminId: string; body: IWriteAdmin }
      >({
        query: ({ adminId, body }) => ({
          url: `/${adminId}`,
          method: HttpMethod.PUT,
          body,
        }),
        invalidatesTags: (_result, _error, { adminId }) => [
          { type: TagType.Restaurant, id: TagId.LIST },
          { type: TagType.Restaurant, id: adminId },
        ],
      }),
      deleteAdmin: builder.mutation<void, string>({
        query: (adminId) => ({
          url: `/${adminId}`,
          method: HttpMethod.DELETE,
        }),
        invalidatesTags: () => [{ type: TagType.Admin, id: TagId.LIST }],
      }),
      fetchAdminDetails: builder.query<Admin, string>({
        query: (adminId) => {
          return {
            url: "/" + adminId,
            method: HttpMethod.GET,
          };
        },
        providesTags: (_result, _error, adminId) => [
          { type: TagType.Admin, id: adminId },
        ],
      }),
    };
  },
});

export const {
  useToggleAdminIsActiveStatusMutation,
  useFetchAdminsQuery,
  useCreateAdminMutation,
  useDeleteAdminMutation,
  useFetchAdminDetailsQuery,
  useUpdateAdminMutation,
} = adminApi;

export { adminApi };
